import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight, FaStar } from "react-icons/fa";
import "./feedback.css";
import { miscService } from "../service/misc.service";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const FeedbackSlider = () => {

    const [feedbackList, setFeedbackList] = useState([]);

    useEffect(() => {
        getAllFeedbackLists()
    }, [])

    const getAllFeedbackLists = async () => {
        try {

            const response = await miscService.getFeedbacks()
            console.log('feedback response is....', response);

            if (response?.data?.rows.length > 0) {
                setFeedbackList(response?.data?.rows)
            }

        } catch (err) {
            console.log(err, "this si error message")
        }
    }

    return (
        <div data-aos="zoom-in-up" className="feedback-slider">
            <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                    nextEl: '.custom-next',
                    prevEl: '.custom-prev',
                }}
                autoplay={{
                    delay: 3000, // 2 seconds
                    disableOnInteraction: false,
                }}
                spaceBetween={30}
                slidesPerView={1}
                loop
                className="feedback-swiper"
            >
                {/* <div className=""> */}
                    {feedbackList?.map((feedback, index) => (
                        <SwiperSlide key={index}>
                            <div className="feedback-card">
                                <div className="feedback-header">
                                    <div className="feedback-reaction-container">
                                        <img src={feedback?.profile_image ? feedback.profile_image : 'https://www.une.edu/sites/default/files/2024-03/default-person.png'} alt="User" className="avatar" />
                                        <p className="feedback-text">{feedback?.reaction}</p>
                                    </div>
                                    <p className="feedback-imoji">{feedback?.image}</p>
                                </div>
                                <p className="feedback-comment">{feedback?.comment}</p>

                                <div className="feedback-author">
                                    <strong>{`${feedback?.first_name} ${feedback?.last_name}`}</strong>
                                    <span>{feedback.role}</span>
                                </div>


                            </div>
                        </SwiperSlide>
                    ))}

                    {/* <div className="slider-arrows">
                        <button className="custom-prev"><FaArrowLeft size={15} /></button>
                        <button className="custom-next"><FaArrowRight size={15} /></button>
                    </div> */}
                {/* </div> */}
            </Swiper>
        </div>
    );
};

export default FeedbackSlider;
